import "./crimsonOak.scss";
import "../perfume.scss";

// Images
// import MainImage from "../../../assets/img/perfume/crimson_oak_main.webp";
import ConcentrationImage from "../../../assets/img/perfume/crimson_oak_concentration.webp";
import Ingredients1 from "../../../assets/img/perfume/ingredients/orange-blossom.webp";
import Ingredients2 from "../../../assets/img/perfume/ingredients/lavender.webp";
import Ingredients3 from "../../../assets/img/perfume/ingredients/lemon.webp";
import Ingredients4 from "../../../assets/img/perfume/ingredients/rosemary.webp";
import Ingredients5 from "../../../assets/img/perfume/ingredients/nutmeg.webp";
import Ingredients6 from "../../../assets/img/perfume/ingredients/coriander.webp";
import Ingredients7 from "../../../assets/img/perfume/ingredients/cardamom.webp";
import Ingredients8 from "../../../assets/img/perfume/ingredients/lichen.webp";
import Details from "../components/details/Details";
import productStore from "../../../store/productStore";
import { useEffect, useState } from "react";
import ProductReview from "../components/productReview/ProductReview";
// import ProductSlider from "../components/productSlider/ProductSlider";
import Ingredients from "../components/ingredients/Ingredients";
// import FirstContent from "../components/firstContent/FirstContent";
import Concentration from "../components/concentration/Concentration";
import SEO from "../../../components/seo/SEO";
import { CRIMSON_OAK_ID } from "../../../constant";
import ProductSliderNew from "../components/productSlider/ProductSliderNew";
import VideoWithEndImageNew from "../components/videoWithEndImage/VideoWithEndImageNew";

import MainVideoWEBM from "assets/video/perfume/crimson_oak/crimson_oak_web.webm";
// import MainVideoMobWEBM from "assets/video/perfume/crimson_oak/crimson_oak_mob.webm";
import MainVideoMobWEBM from "assets/video/perfume/crimson_oak/crimson_oak_mobBG.webm";
import sliderImage1 from "assets/img/perfume/slider/posttrioswipe1co.webp";
import sliderImage2 from "assets/img/perfume/slider/posttrioswipe2co.webp";
import imageLoadStore from "store/imageLoadStore";
import MyLoader from "components/myLoader/MyLoader";

const CrimsonOak = () => {
  const ImageLoadStore = imageLoadStore();
  const ProductStore = productStore();
  const [product, setProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const AccordionDetails = [
    {
      label: "DESCRIPTION",
      content: (
        <div>
          A strong, spicy-woody fragrance built for impact. Crimson Oak begins
          with bright lemon and orange blossom, delivering a fresh yet sharp
          opening. The heart unfolds into aromatic lavender, rosemary, nutmeg,
          coriander, and cardamom for a warm spicy character. It dries down into
          a rich woody base of vetiver, tonka bean, teakwood, and earthy lichen.
          <br />
          <br />
          This long-lasting woody perfume is powerful, sophisticated, and ideal
          for men who want a commanding presence.
        </div>
      ),
    },
    {
      label: "FRAGRANCE NOTES",
      content: (
        <p>
          <strong>Top Notes: </strong>Orange Blossom, Lemon
          <br />
          <strong>Middle Notes: </strong>Lavender, Rosemary, Nutmeg, Coriander,
          Geranium, Cardamom
          <br />
          <strong>Base Notes: </strong>Lichen, Vetiver, Tonka Bean, Teakwood
        </p>
      ),
    },
    {
      label: "FEELINGS",
      content: <p>Dominant • Strong • Mature • Assertive • Refined</p>,
    },
    {
      label: "OCCASIONS",
      content: (
        <ol>
          <li>Formal Events</li>
          <li>Business Meetings</li>
          <li>Winter Evenings</li>
          <li>Special Gatherings</li>
        </ol>
      ),
    },
    {
      label: "BEHIND THE PERFUME",
      content: (
        <p>
          Inspired by strength and depth, Crimson Oak combines citrus freshness
          with layered spices and deep woods. The teakwood and vetiver base
          ensures a bold trail that stays noticeable throughout the day.
        </p>
      ),
    },
    {
      label: "SHIPPING & RETURN",
      content: (
        <p>
          We carefully pack and dispatch all orders to ensure safe delivery.
          Orders are processed within standard business timelines.
          <br />
          <strong>Please note:</strong> Due to hygiene and product safety
          reasons, we do not accept returns or exchanges once the product has
          been delivered.
        </p>
      ),
    },
    {
      label: "LEGAL INFORMATION",
      content: (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <div>
            <p style={{ fontWeight: 700 }}>Marketed by KRISTIVE</p>
            <p>
              105, Shubham Residency 1, Navagam Surat 394210, Gujarat, India
            </p>
          </div>
          <div>
            <p>
              <strong>Customer Care:</strong>
            </p>
            <p>
              <strong>Email</strong> - support@kristive.com
            </p>
            <p>
              <strong>Call</strong> - +91 81601 92573
            </p>
            <p>
              <strong>Website</strong> - www.kristive.com
            </p>
          </div>
          <div>
            <p>
              <strong>Manufactured by</strong>
            </p>
            <p>
              MINATI ESSENTIALS 8, Laxmi Narayan Industries, Udhna Surat,
              Gujarat - 394210
            </p>
            <strong>Lic. No.: </strong>GC/2055
          </div>
          <div>
            <p>
              <strong>Country of Origin:</strong> India
            </p>
            <p>
              <strong>Net Contents:</strong> 50ML / 1.7 fl. oz
            </p>
          </div>
          <div>
            <p>
              <strong>Ingredients:</strong>
            </p>
            <p>
              Linalool, Geraniol, Limonene, Eugenol, Denatured Ethyl Alcohol,
              Fragrance Oil.
            </p>
          </div>

          <div>
            <p>For External Use Only.</p>
            <p>Store in a Cool & Dry Place.</p>
          </div>

          <div>
            <p>
              <strong>Usage:</strong>
            </p>
            <p>
              To avoid staining, spray perfume from a safe distance of 15-20 cm.
            </p>
          </div>
          <div>
            <p>
              <strong>Warning:</strong>
            </p>
            <p>Keep away from children and pets.</p>
            <p>Avoid contact with eyes, mouth, and broken skin.</p>
            <p>Flammable - Keep away from heat, sparks, and open flame.</p>
          </div>

          <div>
            <p>
              <strong>Generic Name:</strong> Perfume
            </p>
            <p>Best Before: 36 months from manufacturing date.</p>
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0 });
    fetchSpecificProductRating();
    if (ImageLoadStore.imageLoading) {
      setTimeout(() => {
        document.body.style.overflowY = "hidden";
      }, 50);
    }
  }, []);

  const fetchSpecificProductRating = async () => {
    setIsLoading(true);
    const product = await ProductStore.fetchOneProduct({
      _id: CRIMSON_OAK_ID,
    });
    setProduct(product);
    setIsLoading(false);
  };

  return (
    <>
      <SEO
        title="Crimson Oak Perfume | Strong Spicy Woody Long-Lasting Fragrance"
        description="Crimson Oak is a powerful spicy-woody perfume with citrus freshness, warm spices, and deep teakwood. A bold, long-lasting fragrance for confident men."
      />
      {ImageLoadStore.imageLoading && (
        <div className="loading">
          <MyLoader height="100vh" />
        </div>
      )}
      <div className="perfume-details crimson-oak">
        <VideoWithEndImageNew
          websiteVideoWEBM={MainVideoWEBM}
          mobileVideoWEBM={MainVideoMobWEBM}
          product={product}
          slogan="Grounded in Earthy Elegance."
        />
        <ProductSliderNew images={[sliderImage1, sliderImage2]} />

        <div className="content">
          {/* <FirstContent
            title={"CRIMSON OAK"}
            shortDescription={"Smell the Strength Within"}
            image={MainImage}
            id={CRIMSON_OAK_ID}
            productName={product?.productName || ""}
            regularPrice={product?.regularPrice || ""}
            salePrice={product?.salePrice || null}
          />

          {product?.productImages.length > 0 && (
            <ProductSlider images={product?.productImages || []} />
          )} */}

          <Ingredients
            Ingredients1={{
              img: Ingredients1,
              name: "Orange Blossom",
              desc: "Fresh floral brightness with a crisp citrus nuance",
            }}
            Ingredients2={{
              img: Ingredients2,
              name: "Lavender",
              desc: "Clean aromatic note with a refined masculine edge",
            }}
            Ingredients3={{
              img: Ingredients3,
              name: "Lemon",
              desc: "Sharp, zesty citrus adding an energizing freshness",
            }}
            Ingredients4={{
              img: Ingredients4,
              name: "Rosemary",
              desc: "Herbal and invigorating with a sharp green intensity",
            }}
            Ingredients5={{
              img: Ingredients5,
              name: "Nutmeg",
              desc: "Warm spice with a dry, slightly sweet depth",
            }}
            Ingredients6={{
              img: Ingredients6,
              name: "Coriander",
              desc: "Fresh spice with a crisp, slightly citrusy edge",
            }}
            Ingredients7={{
              img: Ingredients7,
              name: "Cardamom",
              desc: "Cool, aromatic spice with a smooth exotic warmth",
            }}
            Ingredients8={{
              img: Ingredients8,
              name: "Lichen",
              desc: "Earthy, mossy depth adding a dark woody character",
            }}
          />

          <Concentration
            image={ConcentrationImage}
            percentage={25}
            shortDescription={
              "Elegant Blend of Fruity Freshness and Deep Floral Richness"
            }
          />

          <Details items={AccordionDetails} />

          <ProductReview
            isLoading={isLoading}
            averageRating={product?.averageRating || 0}
            totalReview={product?.ratingCount || 0}
            ratings={product?.ratings || []}
            particularRatings={{
              fiveStar: product?.fiveStar,
              fourStar: product?.fourStar,
              threeStar: product?.threeStar,
              twoStar: product?.twoStar,
              oneStar: product?.oneStar,
            }}
            appBarColor="#4b1717"
          />
        </div>
      </div>
    </>
  );
};

export default CrimsonOak;
